module.exports = __webpack_public_path__ + "img/call_more_icon.afc6f22e.svg";